<template>
    <div class="position-relative d-flex flex-column h-100">
        <div class="flex-grow-1">
            <h2 class="donation-title text-center mb-3">Thank You</h2>
            <div class="donation-desc mb-4" v-text="donationData.thankyou" />
        </div>
        <button @click="submit" class="btn w-100 ok-btn mt-3">Close</button>
    </div>
</template>

<script>
export default {
    name: 'ThankYou',
    props: {
        donationData: {
            type: Object,
            default: () => ({}),
        }
    },
    data() {
        return {
            question1: '',
            question2: '',
        };
    },
    methods: {
        submit() {
            this.$emit('close');
        },
    },
};
</script>
